// App-level UI constants — placeholder copy + similar small literals
// that surface in 3+ screens. Hoisted from the inline declarations in
// `template-editor.tsx` + `email-editor.tsx` at P-037.27 / D-135 when
// the same strings reached 6 surfaces across 3 files for each (editor
// + list + home recent + delete-confirm modal copy).
//
// **These are render-time placeholders, NEVER persisted.** The Zod
// schemas relaxed `Template.name` + `Email.name` from `.min(1)` to
// `z.string()` at D-135 so staff can clear the inline-editable title
// to empty; the placeholder surfaces only at the JSX render seam
// (`name || PLACEHOLDER`) so the data layer stays free of UX strings.
// Renames touch this file alone, not a data migration. See
// `spec/decision-log.md#D-135` for the framing.

export const TEMPLATE_NAME_PLACEHOLDER = 'Untitled template'
export const EMAIL_NAME_PLACEHOLDER = 'Untitled email'

// Editor-button idle-state CTA when the name is empty (P-037.30 / D-138).
// CTA-style copy nudges staff to click the title and name the record;
// the value itself NEVER persists (rendered at the JSX seam only).
// Distinct from PLACEHOLDER which carries the "what to show when name
// is empty" semantic at list rows + delete modals + input placeholder,
// where a CTA would be misplaced ("Untitled email" reads as a label;
// "Click to name this email…" reads as an instruction). Renders
// alongside the pencil glyph + italic styling per the D-138 naming-
// affordance fix.
export const TEMPLATE_NAME_EDIT_PROMPT = 'Click to name this template…'
export const EMAIL_NAME_EDIT_PROMPT = 'Click to name this email…'
